import $ from 'jquery';
import RangeSlider from './RangeSlider';

class FiltersRangeSliders {
  static init(): void {
    const $rangeSliders = $('.js-range-slider');

    $rangeSliders.each((i, el) => {
      console.log('Initializing slider', i, el);
      /* eslint no-unused-vars: ["error", { "varsIgnorePattern": "slider" }] */
      const slider = new RangeSlider(el);
    });
  }
}

export default FiltersRangeSliders;